import * as Complex from '../../../../process-data/complex';

export function computeComplexAlphaPlus() {
  return Complex.createComplex(1, 0);
}

export function computeComplexFF() {
  return Complex.createComplex(0, 0);
}
